import React from 'react';
import { cn } from 'lib/utils';

export interface SectionProps {
    title?: React.ReactNode;
    description?: React.ReactNode;
    icon?: React.ReactNode;
    actions?: React.ReactNode;
    children: React.ReactNode;
    /** 헤더 구분선 바로 아래에 본문을 붙임 (행 구분선이 있는 리스트용) */
    flush?: boolean;
    className?: string;
    bodyClassName?: string;
}

/**
 * 흰 배경 위의 평면 섹션 — 카드(테두리 박스)로 감싸지 않는다.
 * 제목 + 우측 액션 + 하단 헤어라인으로만 구획한다 (DESIGN.md §4 페이지 레이아웃 규칙).
 */
const Section: React.FC<SectionProps> = ({
    title,
    description,
    icon,
    actions,
    children,
    flush = false,
    className = '',
    bodyClassName = '',
}) => {
    const hasHeader = title || description || actions;

    return (
        <section className={cn('pb-4', className)}>
            {hasHeader && (
                <div
                    className={cn(
                        'flex items-end justify-between gap-4 border-b border-border pb-2',
                        !flush && 'mb-4'
                    )}
                >
                    <div className="flex min-w-0 flex-col gap-0.5">
                        {title && (
                            <h2 className="flex items-center gap-2 truncate text-md font-semibold text-foreground [&_svg]:h-4 [&_svg]:w-4 [&_svg]:text-neutral-500">
                                {icon}
                                {title}
                            </h2>
                        )}
                        {description && (
                            <p className="text-xs text-muted-foreground">{description}</p>
                        )}
                    </div>
                    {actions && <div className="flex shrink-0 items-center gap-2">{actions}</div>}
                </div>
            )}
            <div className={cn(bodyClassName)}>{children}</div>
        </section>
    );
};

export default Section;
